import create from 'zustand'
import * as api from '../api/apiCalls'
import { devtools } from 'zustand/middleware'

const store = (set, get) => ({
    isLogged: false,
    userData: {},
    auth: () => {
        let url = "https://discord.com/api/oauth2/authorize?client_id=1045710028453183539&redirect_uri=http%3A%2F%2Flocalhost%3A5010%2Fauth%2FcheckAuth&response_type=code&scope=identify%20guilds%20guilds.join%20messages.read%20role_connections.write"
        window.open(url,"_self")
    },
    logIn: async (token, navigate) => {
        try{
            const data = await api.logIn(token)
            const {encryptedToken} = data.data
            console.log(data.data)
            set((state) => ({isLogged: true}))
            set((state) => ({userData: data.data}))
            window.localStorage.setItem('encryptedToken', encryptedToken);
        }catch(err){
            console.log(err)
            await window.localStorage.removeItem('encryptedToken');
            navigate('/logIn')
        }

    }
})

const userStore = create(devtools(store))

export default userStore